import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { fetchFromRestAPI } from '../util/api';
import { AUTH0_ORGANIZATION_ID } from '../config';
import { UdiDi } from '../../../shared/dtos/tenant.dto';

export function useWebGtin(): string | undefined {
  const { data }: UseQueryResult<UdiDi> = useQuery({
    queryKey: ['public-udi-di'],
    queryFn: (): Promise<UdiDi> =>
      fetchFromRestAPI<UdiDi>(`/api/v1/public/udi-di?tenant=${AUTH0_ORGANIZATION_ID}`),
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
    retry: false,
  });

  return data?.web;
}
